import { render, staticRenderFns } from "./pl-svg.vue?vue&type=template&id=fee03a40&scoped=true"
import script from "./pl-svg.vue?vue&type=script&lang=js"
export * from "./pl-svg.vue?vue&type=script&lang=js"
import style0 from "./pl-svg.vue?vue&type=style&index=0&id=fee03a40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fee03a40",
  null
  
)

export default component.exports